import React, { useState } from "react";
import "./FDScheme.css";

const FixedDepositScheme = () => {
  const [schemes, setSchemes] = useState([]);
  const [formData, setFormData] = useState({
    serviceType: "",
    serviceName: "",
    minDepositAmount: "",
    minDepositTenure: "",
    additionalBonus: "",
    depositLocinPeriod: "",
    interestLocinPeriod: "",
    preClosureRoi: "",
    closureChargeBefore: "",
    closureChargeBeforeType: "",
    closureChargeAfter: "",
    closureChargeAfterType: "",
    loanRoiType: "",
    loanRoi: "",
    loanApprovalPercent: "",
    roi: "",
    roiFrequency: "",
    interestCompounding: "",
    prefix: "",
    schemeStatus: "",
    fixedTenure: "",
    maxDuration: ""
  });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSchemes([...schemes, { ...formData, id: schemes.length + 1 }]);
    setFormData(Object.fromEntries(Object.keys(formData).map(k => [k, ""])));
  };

  const renderInput = (label, name, type = "text", placeholder = "", options = null) => (
    <div className="fdmisform-group">
      <label>{label}</label>
      {options ? (
        <select name={name} value={formData[name]} onChange={handleChange}>
          <option value="">Select</option>
          {options.map((opt, i) => <option key={i} value={opt}>{opt}</option>)}
        </select>
      ) : (
        <input type={type} name={name} value={formData[name]} onChange={handleChange} placeholder={placeholder} />
      )}
    </div>
  );

  return (
    <div className="fdmis-scheme-container">
      <h2>Fixed Deposit Scheme</h2>

      <form className="fdmis-scheme-form" onSubmit={handleSubmit}>
        <div className="fdmisform-row">
          {renderInput("Select Service Type", "serviceType", "text", "", ["FD Type 1","FD Type 2"])}
          {renderInput("Service Name", "serviceName", "text", "Enter service name")}
        </div>

        <div className="fdmisform-row">
          {renderInput("Minimum Deposit Amount", "minDepositAmount", "number", "Enter minimum deposit")}
          {renderInput("Min Deposit Tenure", "minDepositTenure", "number", "Enter minimum tenure")}
        </div>

        <div className="fdmisform-row">
          {renderInput("Additional Bonus (%)", "additionalBonus", "number", "Enter additional bonus")}
          {renderInput("Deposit Locin Period", "depositLocinPeriod", "number", "Enter deposit locin period")}
        </div>

        <div className="fdmisform-row">
          {renderInput("Interest Locin Period", "interestLocinPeriod", "number", "Enter interest locin period")}
          {renderInput("Pre Closure ROI (%)", "preClosureRoi", "number", "Enter preclosure ROI")}
        </div>

        <div className="fdmisform-row">
          {renderInput("Closure Charge Before Locin Period", "closureChargeBefore", "number", "Enter charge")}
          {renderInput("Charge Type", "closureChargeBeforeType", "text", "", ["Fixed","Percentage"])}
        </div>

        <div className="fdmisform-row">
          {renderInput("Closure Charge After Locin Period", "closureChargeAfter", "number", "Enter charge")}
          {renderInput("Charge Type", "closureChargeAfterType", "text", "", ["Fixed","Percentage"])}
        </div>

        <div className="fdmisform-row">
          {renderInput("Loan ROI Type", "loanRoiType", "text", "", ["Reducing","Flat"])}
          {renderInput("Loan ROI (%)", "loanRoi", "number", "Enter loan ROI")}
        </div>

        <div className="fdmisform-row">
          {renderInput("Loan Approval on Deposit (%)", "loanApprovalPercent", "number", "Enter loan approval %")}
          {renderInput("ROI (%)", "roi", "number", "Enter ROI")}
        </div>

        <div className="fdmisform-row">
          {renderInput("ROI Frequency", "roiFrequency", "text", "", ["Daily","Monthly","Quarterly"])}
          {renderInput("Interest Compounding", "interestCompounding", "text", "", ["Monthly","Quarterly","Yearly"])}
        </div>

        <div className="fdmisform-row">
          {renderInput("Prefix", "prefix", "text", "Enter service prefix")}
          {renderInput("Scheme Status", "schemeStatus", "text", "", ["Active","Inactive"])}
        </div>

        <div className="fdmisform-row">
          {renderInput("Is This For Fixed Tenure?", "fixedTenure", "text", "", ["Yes","No"])}
          {renderInput("Fixed/Max Duration", "maxDuration", "text", "Enter duration")}
        </div>

        <button type="submit" className="fdmissubmit-btn">Submit</button>
      </form>

      <div className="fdmisscheme-report">
        <h3>Fixed Deposit Scheme Report</h3>
        <input type="text" placeholder="Search..." className="fdmissearch-input" />
        <table>
          <thead>
            <tr>
              <th>Serial No.</th>
              <th>Action</th>
              <th>Account Type</th>
              <th>Scheme Name</th>
              <th>Prefix</th>
              <th>ROI</th>
              <th>Min. Deposit Installment</th>
            </tr>
          </thead>
          <tbody>
            {schemes.length ? schemes.map(s => (
              <tr key={s.id}>
                <td>{s.id}</td>
                <td>Edit/Delete</td>
                <td>{s.serviceType}</td>
                <td>{s.serviceName}</td>
                <td>{s.prefix}</td>
                <td>{s.roi}</td>
                <td>{s.minDepositAmount}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>No data available in table</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FixedDepositScheme;
